import type { Lead, LeadStatus } from '@/domain/model/Lead';
import type { Page } from '@/domain/model/Page';
import type { LeadGateway } from '@/application/port/out/LeadGateway';
import type {
  ListLeadsUseCase, GetLeadUseCase, MoverLeadStageUseCase, MarcarLeadPerdidoUseCase,
} from '@/application/port/in/LeadUseCase';

export class ListLeads implements ListLeadsUseCase {
  constructor(private readonly g: LeadGateway) {}
  execute(p: { status?: LeadStatus; pipelineId?: string; vendedorId?: string; page?: number; size?: number }): Promise<Page<Lead>> {
    return this.g.list(p);
  }
}
export class GetLead implements GetLeadUseCase {
  constructor(private readonly g: LeadGateway) {}
  execute(id: string): Promise<Lead> { return this.g.get(id); }
}
export class MoverLeadStage implements MoverLeadStageUseCase {
  constructor(private readonly g: LeadGateway) {}
  execute(id: string, stageId: string): Promise<Lead> { return this.g.moverStage(id, stageId); }
}
export class MarcarLeadPerdido implements MarcarLeadPerdidoUseCase {
  constructor(private readonly g: LeadGateway) {}
  execute(id: string, lossReasonId: string | null, motivoLivre: string | null): Promise<Lead> {
    return this.g.marcarPerdido(id, lossReasonId, motivoLivre);
  }
}
